// Farbauswahl (snippets/su-color-group.liquid): beim Klick auf eine Farbe die gewaehlte Groesse mitnehmen.
// Liest das gecheckte Radio des Theme-Pickers und haengt die passende Varianten-ID des Zielprodukts als ?variant= an.
// Ohne gewaehlte Groesse oder ohne Treffer bleibt der Link unveraendert (keine Vorauswahl, Punkt 3).
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.su-color-group__link');
    if (!link || !link.closest('[data-persist-size]')) return;
    const checked = document.querySelector('variant-options input[type="radio"]:checked');
    if (!checked) return;
    let values, ids;
    try {
      values = JSON.parse(link.getAttribute('data-size-values') || '[]');
      ids = JSON.parse(link.getAttribute('data-size-ids') || '[]');
    } catch (e) {
      return;
    }
    const wanted = String(checked.value).trim().toLowerCase();
    const index = values.findIndex((v) => String(v).trim().toLowerCase() === wanted);
    if (index < 0 || !ids[index]) return;
    event.preventDefault();
    window.location.href = link.href.split('?')[0] + '?variant=' + ids[index];
  });
})();
